import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import type { User, Workshop } from '../types';

interface AuthState {
  accessToken: string | null;
  refreshToken: string | null;
  user: User | null;
  activeWorkshop: Workshop | null;
  workshops: Workshop[];
  setAuth: (a: { accessToken: string; refreshToken: string; user: User }) => void;
  setActiveWorkshop: (w: Workshop) => void;
  setWorkshops: (w: Workshop[]) => void;
  clear: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      activeWorkshop: null,
      workshops: [],
      setAuth: ({ accessToken, refreshToken, user }) => set({ accessToken, refreshToken, user }),
      setActiveWorkshop: (activeWorkshop) => set({ activeWorkshop }),
      setWorkshops: (workshops) => set({ workshops }),
      clear: () =>
        set({
          accessToken: null,
          refreshToken: null,
          user: null,
          activeWorkshop: null,
          workshops: [],
        }),
    }),
    {
      name: 'autoservice-auth',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
